import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';

@Injectable()
export class ScriptService {
  private loaded = false;
  private list: any = {};
  private emitter: Subject<boolean> = new Subject<boolean>();

  constructor(@Inject(DOCUMENT) private doc: any) {}

  getChangeEmitter() {
    return this.emitter;
  }

  load(path: string) {
    if (this.loaded) {
      return this;
    }

    this.loaded = true;

    const promises: Promise<any>[] = [];

    [path].forEach(script => promises.push(this.loadScript(script)));

    Promise.all(promises).then(res => {
      this.emitter.next(true);
    });

    return this;
  }

  loadScript(path: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.list[path] === true) {
        resolve({
          path,
          loaded: true,
          status: 'Loaded',
        } as any);
        return;
      }

      this.list[path] = true;

      const node = this.doc.createElement('script');
      node.type = 'text/javascript';
      node.src = path;
      node.charset = 'utf-8';
      if ((node as any).readyState) {
        // IE
        (node as any).onreadystatechange = () => {
          if (
            (node as any).readyState === 'loaded' ||
            (node as any).readyState === 'complete'
          ) {
            (node as any).onreadystatechange = null;
            resolve({
              path,
              loaded: true,
              status: 'Loaded',
            } as any);
          }
        };
      } else {
        node.onload = () => {
          resolve({
            path,
            loaded: true,
            status: 'Loaded',
          } as any);
        };
      }
      node.onerror = (error: any) =>
        resolve({
          path,
          loaded: false,
          status: 'Loaded',
        } as any);
      this.doc.getElementsByTagName('head')[0].appendChild(node);
    });
  }
}
